import httpClient from '../../../api/httpClient';
import API_CONFIG from '../../../config/api.config';

// --- Types for complete payment receive transaction ---
export interface PaymentReceiveCompletePayload {
  paymentReceive: {
    paymentTransactionNumber: string;
    paymentDate: string;
    totalPaymentReceived: number;
    status: string;
    patientId: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
    isDeleted: boolean;
    comment?: string;
    totalReceived?: number;
    changesDue?: number;
    totalDiscount?: number;
  };
  paymentReceiveOrders: Array<{
    appointmentOrderId: string;
    amountApplied: number;
    createdBy: string;
    createdAt: string;
    isDeleted: boolean;
  }>;
  paymentReceivePaymentModes: Array<{
    paymentMode: string;
    amount: number;
    reference?: string;
    createdBy: string;
    createdAt: string;
    isDeleted: boolean;
  }>;
}

export interface PaymentReceiveCompleteResponse {
  success: boolean;
  paymentReceiveId?: string;
  message?: string;
}

const API_URL = '/api/payment-receive/complete';

/**
 * Create a payment receive transactionally with all child records.
 */
export const createPaymentReceiveComplete = async (
  payload: PaymentReceiveCompletePayload
): Promise<PaymentReceiveCompleteResponse> => {
  const { data } = await httpClient.post(API_URL, payload);
  return data;
};
